<template>
    <div class="ui-graph">
        <div class="ui-graph__content"
             v-if="isReady"
        >
            <apexchart
                type="donut"
                width="100%"
                height="100%"
                :options="options"
                :series="series"
            />
        </div>
        <div class="ui-graph__loader"
             v-else
        >
            <ui-loader
                v-bind:fixed="50"
                v-bind:centered="true"
            />
        </div>
    </div>
</template>

<script>
import utils from '~/utils';

export default {
    name: 'ui-graph-donut',
    props: {
        series: {
            type: [],
        },
        labels: {
            type: [],
        },
        outsideLabels: {
            type: [],
        }, // TODO
        colors: {
            type: [],
            default: null,
        },
        customTooltip: {
            type: String,
            default: '',
        },
    },
    data: function() {
        return {
            isReady: false,
        };
    },
    computed: {
        options() {
            return {
                colors: this.colors ?? [],
                labels: this.labels,

                plotOptions: {
                    pie: {
                        expandOnClick: true,
                        offsetX: 0,
                        offsetY: 2,
                        customScale: 1.1,
                        dataLabels: {
                            enabled: true,
                            offset: 48,
                            minAngleToShowLabel: 0,
                            textAnchor: 'middle',
                        },
                        donut: {
                            size: '54%',
                            textAnchor: 'middle',
                        },
                    },
                },
                tooltip: {
                    enabled: true,
                    followCursor: true,
                    custom: ({ seriesIndex }) => {
                        this.$emit('hoverTooltip', seriesIndex);
                        return this.customTooltip || '';
                    },
                },
                theme: {
                    monochrome: {
                        enabled: !(this.colors && this.colors?.length),
                        color: '#9155EB',
                        shadeTo: 'dark',
                        // shadeTo: 'light',
                        shadeIntensity: 0.65,
                    },
                },
                dataLabels: {
                    enabled: false,
                    /* formatter: (val, opts) =>  {
                        return `${this.outsideLabels[opts.seriesIndex][0]} ${this.series[opts.seriesIndex]}%`;
                    }, */
                    textAnchor: 'middle',
                    dropShadow: {
                        enabled: false,
                    },
                    style: {
                        fontSize: '14px',
                        fontFamily: 'Helvetica, Arial, sans-serif',
                        fontWeight: 'bold',
                        colors: undefined,
                    },
                },
                legend: {
                    show: false,
                    position: 'left',
                    fontSize: '16px',
                    fontFamily: 'Noah, Helvetica, Arial, sans-serif',
                },
            };
        },
    },
    mounted() {
        utils.dom.addLoadedCallback(this.activate);
    },
    beforeDestroy() {
        utils.dom.removeLoadedCallback(this.activate);
    },
    methods: {
        activate() {
            this.isReady = true;
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.ui-graph {
    .transition-fade();

    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: stretch;
    height: 100%;
    width: 100%;
    min-width: 180px;
    min-height: 180px;

    &__content {
        flex: 1 1 auto;
        height: 100%;
        width: 100%;
    }
    &__loader {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
    }
}
</style>
